import React from "react";

import Toolbar from "../../../../components/tasklayout/toolbar/Toolbar";
import Viewbar from "../../../../components/tasklayout/toolbar/features/viewbar/Viewbar";
import { getCardInfo } from "../../../../lib/getCardInfo";
import { TaskPageEnums } from "../../../../utils/Enums/TaskPageEnums";
import { useTaskFilter } from "../../../../utils/Context/TaskFilterContext";
import useProjectTaskList from "../../hooks/useProjectTaskList";

const AllTasks = () => {
    const { resetFilters } = useTaskFilter();

    const {
        projectId,
        cardData,
        taskList,
        showCompleted,
        hasMore,
        totalCount,
        isInitialLoad,
        isRefreshing,
        isLoadingMore,
        hasActiveFilters,
        hasActiveSearch,
        isError,
        onToggleChange,
        onSearchChange,
        handleRefreshGrid,
        handleLoadMore,
        handleRetry,
        patchTask,
    } = useProjectTaskList({
        getExtraFilter: ({ projectId: currentProjectId }) => ({
            Field: "ProjectId",
            Operator: "Is",
            Value: currentProjectId?.toString() || "0",
        }),
    });

    return (
        <>
            {cardData?.length > 0 && (
                <div className="card-section-info">
                    {getCardInfo(cardData)}
                </div>
            )}
            <div className="task-layout">
                <div>
                    <Viewbar
                        projectId={projectId}
                        showCompleted={showCompleted}
                        onToggleChange={onToggleChange}
                        onSearchChange={onSearchChange}
                        taskFilterPageId={TaskPageEnums.ALL}
                    />
                </div>
                <div className="task-layout-toolbar">
                    <Toolbar
                        projectId={projectId}
                        taskListData={taskList}
                        isTeamPlanning={false}
                        allowEditStatus={true}
                        allowEditAssignee={true}
                        isShowActualTime={false}
                        isDataLoading={isInitialLoad}
                        isRefreshing={isRefreshing}
                        isError={isError}
                        onRetry={handleRetry}
                        onClearFilters={resetFilters}
                        hasActiveFilters={hasActiveFilters}
                        hasActiveSearch={hasActiveSearch}
                        onRefreshGrid={handleRefreshGrid}
                        onLoadMoreTasks={handleLoadMore}
                        isLoadingMore={isLoadingMore}
                        hasMore={hasMore}
                        totalCount={totalCount}
                        onTaskPatch={patchTask}
                    />
                </div>
            </div>
        </>
    );
};

export default AllTasks;
